

<div class="contact-section" style="margin-top:10%;margin-bottom:10%">
  
    <div class="main-about">
      <div class="section">
        <div class="container">
          <div class="col-md-12 col-sm-12">
            <div class="jumbotron text-center">
                <!-- <h1>Thank You !!</h1> -->
                <img src="../../../../../assets/images/tick1.png">
                <h4 style="margin-top:2%">Your Email has been verified successfully.</h4>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>


// WEBPACK FOOTER //
// ./src/app/core/pages/admin/emailVerify/emailVerify.component.html